<template>
  <v-dialog
    v-model="dialog"
    hide-overlay
    persistent
    :width="dialogWidth"
    v-bind="$attrs"
  >
    <v-card class="mx-auto" :max-width="dialogWidth">
      <v-card-text class="text-center">
        <br />
        <i :class="circleClass" :style="circleStyle"></i>
      </v-card-text>
      <v-card-title class="d-flex justify-content-center">
        <p class="text-center" style="word-break: normal;">
          {{ text }}
        </p>
      </v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    circleSize: {
      type: Number,
      required: false,
      default: 8
    },
    dialogWidth: {
      type: Number,
      required: false,
      default: 350
    },
    circleColour: {
      type: String,
      required: false,
      default: "red"
    },
    text: {
      type: String,
      required: true
    },
    dialog: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    circleStyle() {
      return {
        color: this.circleColour
      };
    },
    circleClass() {
      return [
        "fas",
        "fa-spinner",
        "fa-spin",
        `fa-${this.circleSize}x`,
        "fa-fw"
      ];
    }
  }
};
</script>
